import { Button, Form, Header } from "semantic-ui-react";
import axios from "axios";
import { exportData } from "./exportData";
import { useState } from "react";
import { CountrySelect } from "react-country-state-city";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const HangarData = () => {
  const [dateFilter, setDateFilter] = useState("");
  const [country, setCountry] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const handleFetch = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://tower.paperairmedia.com/api/getRequests",
        {
          headers: {
            Accept: "application/json",
          },
          params: {
            country: country?.name,
            startDate: startDate
              ? moment(startDate).format("YYYY-MM-DD")
              : null,
            endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      console.log("Data:", response.data);
      setLoading(false);
      exportData(response.data, "export", "xlsx");
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        background:
          "linear-gradient(135deg, rgba(2, 0, 36, 1) 0%, rgba(9, 9, 121, 1) 35%, rgba(0, 212, 255, 1) 100%)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: "500px",
          minWidth: "300px",
          backgroundColor: "#F1F1F1",
          padding: "30px",
          borderRadius: "20px",
        }}
      >
        <Header as="h1" style={{ textAlign: "center" }}>
          The Hangar Global
          <Header.Subheader>Form Submission Database</Header.Subheader>
        </Header>
        <Form size="large">
          <Header>
            Optional Filters
            <Header.Subheader>
              Selecting a Country will return only records matching that
              country.
            </Header.Subheader>
            <Header.Subheader>
              Entering a Date Range will return only records received during
              that range.
            </Header.Subheader>
            <Header.Subheader>
              Leave all filters blank to get all records.
            </Header.Subheader>
          </Header>
          <Form.Field>
            <label>Country</label>
            <CountrySelect
              defaultValue={country?.id}
              src="/min/"
              placeHolder="Select Country"
              onChange={(country) => {
                setCountry(country);
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Start Date</label>
            <DatePicker
              placeholderText="Select Start Date"
              dateFormat="MMMM d, yyyy"
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>End Date</label>
            <DatePicker
              disabled={!startDate}
              placeholderText="Select End Date"
              dateFormat="MMMM d, yyyy"
              selected={endDate}
              minDate={startDate}
              maxDate={Date.now()}
              onChange={(date) => {
                setEndDate(date);
              }}
            />
          </Form.Field>
          <Button
            size="large"
            loading={loading}
            disabled={loading}
            fluid
            icon="download"
            content="Export"
            primary
            onClick={handleFetch}
          />
        </Form>
      </div>
    </div>
  );
};

export default HangarData;
